/* eslint-disable no-template-curly-in-string */
import { object, string } from 'yup';

export const categoryValidationSchema = object().shape({
    name: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required'),
    description: string()
        .min(2)
        .max(180)
        .optional()
});
